const pages = {
    show: "Visualizar",
    alterStatus: "Reativar ou Inativar",
    edit: "Editar",
    create: "Cadastrar",
    list: null,
    notFound: null
}

const login = {
    currentCategory: "",
    entity: "",
    href: ""
}

const dashboard = {
    currentCategory: "Dashboard",
    entity: "",
    href: "dashboard"
}
const servicoAcolhimento = {
    currentCategory: "Serviços de Acolhimento",
    entity: "",
    href: "servico-acolhimento"
}

const crianca = {
    currentCategory: "Crianças e Adolescentes",
    entity: "",
    href: "crianca"
}

const relatoriosPendencia = {
    currentCategory: "Relatórios",
    entity: "Relatório de Pendências",
    href: "relatorios-pendencia"
}

const relatoriosCriancasAdolescentes = {
    currentCategory: "Relatórios",
    entity: "Relatório de Crianças e Adolescentes",
    href: "relatorios-crianca-adolescente"
}

const relatoriosServicoAcolhimento = {
    currentCategory: "Relatórios",
    entity: "Relatório de Serviço de Acolhimento",
    href: "relatorios-servico-acolhimento"
}

const motivoSituacao = {
    currentCategory: "Cadastros",
    entity: "Motivo de Situação",
    href: "motivo-situacao"
}

const tipoServicoAcolhimento = {
    currentCategory: "Cadastros",
    entity: "Tipo de Serviço de Acolhimento",
    href: "tipo-servico-acolhimento"
}

const doenca = {
    currentCategory: "Cadastros",
    entity: "Doenças",
    href: "doenca"
}

const situacaoJuridica = {
    currentCategory: "Cadastros",
    entity: "Situação Jurídica",
    href: "situacao-juridica"
}

const perfilAcesso = {
    currentCategory: "Cadastros",
    entity: "Perfis de Acesso",
    href: "perfil-acesso"
}

const visitas = {
    currentCategory: "Agenda de Visitas",
    entity: "",
    href: "visitas/lista"
}

const filaProcessamento = {
    currentCategory: "Fila de Processamento",
    entity: "",
    href: "fila-processamento"
}

const auditoria = {
    currentCategory: "Auditoria",
    entity: "",
    href: "auditoria"
}

const auditoriaServico = {
    currentCategory: "Auditoria",
    entity: "",
    href: "auditoria"
}

const auditoriaCrianca = {
    currentCategory: "Auditoria",
    entity: "",
    href: "auditoria"
}

const notFound = {
    currentCategory: "Página não encontrada",
    entity: "",
    href: ""
}

function selectPage(entity, page) {

    if (!isNaN(parseInt(page))) {
        entity["page"] = pages.show;

    } else if (page === "lista") {
        entity["page"] = pages.list;
    }
    else if (page === "alterar-vigencia") {
        entity["page"] = pages.alterStatus;
    }
    else if (page === "cadastrar") {
        entity["page"] = pages.create;
    }
    else if (page === "editar") {
        entity["page"] = pages.edit;
    }
    else if (page !== undefined) {
        if (page.includes("-")) {
            let temp = page.split("-").map((name) => name[0].toUpperCase() + name.substring(1)).join(" ");
            if (temp === "Servico Acolhimento") {
                entity["page"] = "Serviço de Acolhimento"
            } else if (temp === "Crianca Pendencias") {
                entity["page"] = "Pendências Crianças e Adolescentes";
            } else if (temp === "Servico Acolhimento Pendencias") {
                entity["page"] = "Pendências Serviço de Acolhimento";
            } else {
                entity["page"] = temp;
            }
        }
        else {
            if (page === "crianca") {
                entity["page"] = "Crianças e Adolescentes";
            }
        }
    }
    else {
        entity["page"] = pages.notFound;
    }
    return entity;
}

export function checkEntity(entity, page) {

    if (entity === "" || undefined) {
        return selectPage(login, page);
    } else if (entity === "tipo-servico-acolhimento") {
        return selectPage(tipoServicoAcolhimento, page);
    } else if (entity === "dashboard") {
        return selectPage(dashboard, page);
    }
    else if (entity === "doenca") {
        return selectPage(doenca, page);
    }
    else if (entity === "situacao-juridica") {
        return selectPage(situacaoJuridica, page);
    }
    else if (entity === "motivo-situacao") {
        return selectPage(motivoSituacao, page);
    }
    else if (entity === "perfil-acesso") {
        return selectPage(perfilAcesso, page);
    }
    else if (entity === "relatorios-pendencia") {
        return selectPage(relatoriosPendencia, page);
    }
    else if (entity === "relatorios-crianca-adolescente") {
        return selectPage(relatoriosCriancasAdolescentes, page);
    }
    else if (entity === "relatorios-servico-acolhimento") {
        return selectPage(relatoriosServicoAcolhimento, page);
    }
    else if (entity === "servico-acolhimento") {
        return selectPage(servicoAcolhimento, page);
    } else if (entity === "visitas") {
        return selectPage(visitas, page);
    } else if (entity === "fila-processamento") {
        return selectPage(filaProcessamento, page);
    } else if (entity === "auditoria") {
        if (page === "servico") {
            return { ...auditoriaServico, page: "Detalhamento de Serviço de Acolhimento" };
        } else if (page === "crianca") {
            return { ...auditoriaCrianca, page: "Detalhamento de Criança e Adolescente" };
        }
        return { ...auditoria, page: null };
    } else if (entity === "crianca") {
        return selectPage(crianca, page);
    } else {
        return selectPage(notFound, page)
    }

}